import * as React from 'react';
import { Header1, Header3, Paragraph1, Image, useDeviceType } from '@cian/ui-kit';

import { Wrapper } from '../Wrapper';
import { IFrequentlyAskedQuestionSchema } from '../../repositories/legal-check/entities/questions/FrequentlyAskedQuestionSchema';

import * as styles from './styles.css';

export interface IQuestionsProps {
  questions: IFrequentlyAskedQuestionSchema[];
}

export const Questions: React.FC<IQuestionsProps> = ({ questions }) => {
  const isDesktop = useDeviceType() === 'desktop';
  const imgSize = isDesktop ? 64 : 40;

  return (
    <div className={styles['container']}>
      <Wrapper>
        <div className={styles['title']}>
          <Header1>Часто задаваемые вопросы</Header1>
        </div>
        <div className={styles['questions']}>
          {questions.map((item, index) => {
            return (
              <div key={index} className={styles['questions-block']}>
                <div className={styles['question']}>
                  <Image src={item.question.imgUrl} width={imgSize} height={imgSize} borderRadius="50%" />
                  <div className={styles['text']}>
                    <Header3>{item.question.text}</Header3>
                  </div>
                </div>
                <div className={styles['answer']}>
                  <Image src={item.answer.imgUrl} width={imgSize} height={imgSize} borderRadius="50%" />
                  <div className={styles['text']}>
                    <Paragraph1>{item.answer.text}</Paragraph1>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Wrapper>
    </div>
  );
};

Questions.displayName = 'Questions';
